import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import classes from './StatusFilter.module.scss';
import BasicFilterDropdown from '../BasicFilterDropdown/BasicFilterDropdown';
import { responsiveSizeTimesheet, timesheetsStatuses } from '../../../../../../utils/constants';
import BasicDropdownOption from '../BasicDropdownOption/BasicDropdownOption';
import { useWindowSize } from '../../../../../../utils/hooks';

function Marker({ color }) {
  return <div style={{ width: '16px', height: '16px', borderRadius: '100%', backgroundColor: color }}>&nbsp;</div>;
}

export default function StatusFilter({
  selectedStatus,
  changeStatus,
  isApprover = false,
  avaliableStatuses = [],
  dateBackAction
}) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const size = useWindowSize();
  const statuses = [
    { label: t('common.general.all'), color: '#F6F7F9' },
    ...Object.values(timesheetsStatuses(t, isApprover)).filter((stat) => avaliableStatuses.includes(stat.apiStatus))
  ];

  const handleFilterToggle = () => {
    setOpen(!open);
    dateBackAction('', '', selectedStatus);
  };

  return (
    <BasicFilterDropdown
      type={t('dashboard.timesheets.filters.statuses')}
      text={
        !selectedStatus || selectedStatus === t('common.general.all')
          ? t('dashboard.timesheets.filters.statuses')
          : selectedStatus
      }
      active={!!selectedStatus && selectedStatus !== t('common.general.all')}
      open={open}
      setOpen={handleFilterToggle}
      extraHeader={{
        enabled: !!selectedStatus,
        label: t('common.filters.reset'),
        action: () => {
          changeStatus('');
          setOpen(false);
        }
      }}
    >
      <div className={classes.container}>
        {statuses.map((status) =>
          size.width > responsiveSizeTimesheet ? (
            <BasicDropdownOption
              key={status.label}
              text={status.label}
              selected={selectedStatus === status.label}
              clickHandler={() => {
                changeStatus(status.label);
                setOpen(false);
              }}
              icon={<Marker color={status.color} />}
            />
          ) : (
            <Chip
              variant={selectedStatus === status.label ? 'filled' : 'outlined'}
              key={status.label}
              label={status.label}
              onDelete={() => {}}
              deleteIcon={
                <div style={{ marginRight: '8px' }}>
                  {status.label === t('common.general.all') ? null : <Marker color={status.color} />}
                </div>
              }
              onClick={() => {
                changeStatus(status.label);
                setOpen(false);
              }}
              sx={{
                '&.MuiChip-root': {
                  backgroundColor: selectedStatus === status.label ? '#003B58' : '#F6F7F9',
                  color: selectedStatus === status.label ? '#FFFFFF' : '#77787B',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  fontSize: '16px',
                  lineHeight: '19px'
                }
              }}
            />
          )
        )}
      </div>
    </BasicFilterDropdown>
  );
}
